module.exports = __webpack_public_path__ + "static/img/downpost.89c549bb.png";